import { useState, useEffect } from "react";
import {
    X,
    CheckCircle,
    MessageSquareMore,
    User,
    Tag,
    Check,
    Shield,
    TriangleAlert,
    MessageSquare,
    ChevronDown, ChevronRight
} from "lucide-react";
import { Database } from 'lucide-react';
import heartLoading from "../../../assests/heartLoading.gif";
import GlossaryKpiLineage from "./GlossaryKpiLineage";
import parse from 'html-react-parser';
import Tooltip from "@mui/material/Tooltip";
import { Info } from 'lucide-react';
import axios from "axios";
import { toast } from "react-hot-toast";
import { issueOptions } from "../../../constants/Dashboard"
import { createTheme, ThemeProvider } from '@mui/material/styles';


// Utility function to check if data is empty
const isEmpty = (value) => {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string') {
        const stripped = value
            .trim()
            .replace(/\u00a0/g, "")
            .replace(/&nbsp;/g, "")
            .trim();
        return !stripped || stripped === "NA" || stripped.length === 0;
    }
    if (Array.isArray(value)) {
        return value.length === 0;
    }
    return false;
};
const tooltipTheme = createTheme({
    components: {
        MuiPopper: {
            styleOverrides: {
                root: {
                    zIndex: '10000 !important',
                },
            },
        },
    },
});

// Reusable component for "No Data" message
const NoDataMessage = () => (
    <span className="text-gray-400 text-xs italic">
        We don't have any details to show you
    </span>
);
const NoCommunityMessage = () => (
    <span className="text-gray-400 text-xs italic">
     Community Level Not Mapped
    </span>
);

export default function ModalPop({ term, onClose, onSave, assetDetail, assetDetailLoading, onFeedbackSubmit }) {
    const attributes = assetDetail?.attributes || [];
    const businessContext = attributes.find(a => a.type === "Business Context")?.value || null;
    const [showCommentModal, setShowCommentModal] = useState(false);
    const [showReportModal, setShowReportModal] = useState(false);
    const [activeTab, setActiveTab] = useState("overview");
    const [commentText, setCommentText] = useState("");
    const [reportText, setReportText] = useState("");
    const [feedbackList, setFeedbackList] = useState([]);
    const [feedbackLoading, setFeedbackLoading] = useState(false);
    const [commentType, setCommentType] = useState("General Comment");
    const [issueType, setIssueType] = useState("Needs Review");
    const [issueDropdownOpen, setIssueDropdownOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [issuesOpen, setIssuesOpen] = useState(true);
    const [commentsOpen, setCommentsOpen] = useState(true);

    const stripHtml = (html) => {
        if (!html) return "";
        if (/<[^>]+>/.test(html)) {
            const doc = new DOMParser().parseFromString(html, "text/html");
            return doc.body.textContent?.trim() || "";
        }
        return html;
    };
    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const day = String(d.getUTCDate()).padStart(2, "0");
        const month = d.toLocaleString("en-GB", { month: "short", timeZone: "UTC" });
        const year = String(d.getUTCFullYear()).slice(-2);
        return `${day} ${month} '${year}`;
    };

    const termData = {
        term: assetDetail?.displayName || null,
        assetType: assetDetail?.assetType || null,
        department: assetDetail?.domain?.name || null,
        status: assetDetail?.status || null,
        definition: assetDetail?.definition || null,
        description: assetDetail?.description || null,
        formula: assetDetail?.formula || null,
        cl3Community: assetDetail?.cl3Community || null,
        businessContext: businessContext,
        owner: assetDetail?.owner?.trim() || null,
        classification: null,
        certificate: null,
        date: term?.date || null,
        qualityScore: 0,
        source: assetDetail?.source || null,
        tags: assetDetail?.tags || [],
        isCDE: term?.isCDE ?? null,

    };

    const [isEditing, setIsEditing] = useState(false);
    const [editedData, setEditedData] = useState(termData);
    useEffect(() => {
        setEditedData(termData);
    }, [assetDetail]);
    useEffect(() => {
        if (assetDetail?.id) fetchFeedback();
    }, [assetDetail?.id]);

    if (!term) return null;

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleCancel = () => {
        setEditedData(termData);
        setIsEditing(false);
    };

    const handleSave = () => {
        if (onSave) {
            onSave(editedData);
        }
        setIsEditing(false);
    };
    const handleFeedbackSubmit = async (type, message, category) => {
        try {
            const userId = localStorage.getItem("userId");
            await axios.post(
                `${process.env.REACT_APP_API_URL}/collibra/assets/${assetDetail?.id}/feedback`,
                { userId, feedbackType: type, message, feedbackCategory: category }
            );
            if (onFeedbackSubmit) {
                onFeedbackSubmit(term.id, type)
            }
            toast.success(type === "COMMENT" ? "Comment submitted successfully!" : "Issue reported successfully!");
            fetchFeedback();
            if (type === "COMMENT") { setShowCommentModal(false); setCommentText(""); }
            else { setShowReportModal(false); setReportText(""); }
        } catch (error) {
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsSubmitting(false)
        }
    };
    const fetchFeedback = async () => {
        try {
            setFeedbackLoading(true);
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/collibra/assets/${assetDetail?.id}/feedback`
            );
            setFeedbackList(res.data?.feedback || []);
        } catch (e) {
            setFeedbackList([]);
        } finally {
            setFeedbackLoading(false);
        }
    };



    const handleChange = (field, value) => {
        setEditedData(prev => ({ ...prev, [field]: value }));
    };
    if (assetDetailLoading) {
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
                <div className="bg-white rounded-lg w-[50%] h-[400px] flex items-center justify-center">
                    <div className="flex flex-col items-center space-y-3">
style={{ width : 200}}                        <span className="text-gray-700 text-[20px] text-center">
                            Loading  details...
                        </span>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <ThemeProvider theme={tooltipTheme}>
            <div className="fixed top-0 left-0 right-0 bottom-0 z-[9999] flex items-center justify-center bg-black/40">
                <div className="w-[55%]  min-h-[500px] max-h-[90vh] rounded-lg bg-white shadow-xl overflow-y-auto">
                    <div className="flex h-full">
                        {/* LEFT PANEL */}
                        <div className="flex-1 border-r p-3 min-h-[500px]">
                            {/* Header */}
                            <div className="flex items-start justify-between">
                                <div>
                                    <div className="flex items-center gap-[3px]">
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                value={editedData.term}
                                                onChange={(e) => handleChange('term', e.target.value)}
                                                className="text-lg font-semibold border-b-2 border-blue-500 outline-none px-1"
                                            />
                                        ) : (
                                            <h2 className="text-lg font-semibold">{editedData.term}</h2>
                                        )}
                                        <CheckCircle className="h-4 text-green-400" />
                                    </div>

                                </div>


                            </div>

                            {/* Tabs */}
                            <div className="mt-4 flex gap-6 border-b text-sm">
                                <button
                                    onClick={() => setActiveTab("overview")}
                                    className={`pb-2 font-medium ${activeTab === "overview" ? "border-b-2 border-blue-600" : "text-gray-500"}`}
                                >
                                    Overview
                                </button>
                                <button
                                    onClick={() => setActiveTab("feedback")}
                                    className={`pb-2 font-medium ${activeTab === "feedback" ? "border-b-2 border-blue-600" : "text-gray-500"}`}
                                >
                                    Feedback ({feedbackList.length})
                                </button>
                                {termData.assetType === "KPI" && (
                                    <button
                                        onClick={() => setActiveTab("kpi-lineage")}
                                        className={`pb-2 font-medium ${activeTab === "kpi-lineage" ? "border-b-2 border-blue-600" : "text-gray-500"}`}
                                    >
                                        KPI Lineage
                                    </button>
                                )}
                            </div>

                            {/* Definition */}
                            {/* Definition */}

                            {activeTab === "overview" && (
                                <div>
                                    <div className="mt-4">
                                        <p className="text-sm font-medium">Definition</p>

                                        {isEditing ? (
                                            <textarea
                                                value={editedData.definition || ''}
                                                onChange={(e) => handleChange('definition', e.target.value)}
                                                className="mt-1 w-full text-sm outline-none focus:border-blue-500"
                                                rows={3}
                                            />
                                        ) : (
                                            <div className="mt-1 text-sm text-black prose max-w-none h-[55px] overflow-y-auto p-2
                                               [&::-webkit-scrollbar]:w-1
                                                 [&::-webkit-scrollbar-track]:bg-[#EDE9F3]
                                                    [&::-webkit-scrollbar-track]:rounded-full
                                                  [&::-webkit-scrollbar-thumb]:bg-[#7C3AED]
                                                  [&::-webkit-scrollbar-thumb]:rounded-full
                                                [&::-webkit-scrollbar-thumb:hover]:bg-[#6D28D9]"
                                                style={{ scrollbarWidth: 'thin', scrollbarColor: '#7C3AED #EDE9F3' }}
                                            >
                                                {(() => {
                                                    const hasValue = (val) => {
                                                        if (!val) return false;
                                                        const stripped = stripHtml(val)
                                                            ?.trim()
                                                            .replace(/\u00a0/g, "")
                                                            .replace(/&nbsp;/g, "")
                                                            .trim();
                                                        return stripped && stripped !== "NA" && stripped.length > 0;
                                                    };
                                                    const hasDefinition = hasValue(editedData.definition);
                                                    const hasDescription = hasValue(editedData.description);
                                                    if (!hasDefinition && !hasDescription) {
                                                        return <NoDataMessage />;
                                                    }
                                                    return (
                                                        <>
                                                            {hasDefinition && (
                                                                <div>
                                                                    {/<[^>]+>/.test(editedData.definition)
                                                                        ? parse(editedData.definition)
                                                                        : stripHtml(editedData.definition)}
                                                                </div>
                                                            )}
                                                            {hasDescription && (
                                                                <div>
                                                                    {/<[^>]+>/.test(editedData.description)
                                                                        ? parse(editedData.description)
                                                                        : stripHtml(editedData.description)}
                                                                </div>
                                                            )}
                                                        </>
                                                    );
                                                })()}
                                            </div>
                                        )}
                                    </div>

                                    {/* Formula */}
                                    {/* Formula */}
                                    <div className="mt-4">
                                        <div className="mt-2 rounded bg-[#EDE9F3] p-3">
                                            <p className="text-sm font-medium text-black mb-[6px]">Formula</p>
                                            {isEditing ? (
                                                <input
                                                    type="text"
                                                    value={attributes.find(a => a.type === "Calculation Rule")?.value || ''}
                                                    onChange={(e) => handleChange('formula', e.target.value)}
                                                    className="w-full font-mono text-sm text-[#7C3AED] bg-white border border-gray-300 rounded px-2 py-1 outline-none focus:border-blue-500"
                                                />
                                            ) : (
                                                <div className="font-mono text-sm text-[#7C3AED] h-[40px] overflow-y-auto prose prose-sm
                                                  [&::-webkit-scrollbar]:w-1
                                                 [&::-webkit-scrollbar-track]:bg-[#EDE9F3]
                                                    [&::-webkit-scrollbar-track]:rounded-full
                                                  [&::-webkit-scrollbar-thumb]:bg-[#7C3AED]
                                                  [&::-webkit-scrollbar-thumb]:rounded-full
                                                [&::-webkit-scrollbar-thumb:hover]:bg-[#6D28D9]"
                                                    style={{ scrollbarWidth: 'thin', scrollbarColor: '#7C3AED #EDE9F3' }}
                                                >
                                                    {(() => {
                                                        const calculationRule = attributes.find(a => a.type === "Calculation Rule")?.value;
                                                        if (isEmpty(calculationRule)) return <NoDataMessage />;
                                                        return /<[^>]+>/.test(calculationRule)
                                                            ? parse(calculationRule)
                                                            : calculationRule;
                                                    })()}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Business Context */}
                                    {editedData.businessContext && (
                                        <div className="mt-4">
                                            <p className="text-sm font-medium">Business Context</p>
                                            <p className="mt-1 text-sm text-black">{isEmpty(editedData.businessContext) ? <NoDataMessage /> : editedData.businessContext}</p>
                                        </div>
                                    )}



                                    {/* Tags */}
                                    <div className="mt-4">
                                        <p className="text-sm font-medium flex gap-[4px] items-center">
                                            <Tag size={12} />
                                            Tags
                                        </p>
                                        <div className="mt-2 flex flex-wrap gap-2">
                                            {Array.isArray(editedData.tags) && editedData.tags.length > 0 ? (
                                                editedData.tags.map((tag, index) => (
                                                    <span
                                                        key={index}
                                                        className="rounded bg-gray-600 text-white px-2 py-1 text-xs rounded-lg"
                                                    >
                                                        {tag}
                                                    </span>
                                                ))
                                            ) : (
                                                <NoDataMessage />
                                            )}
                                        </div>
                                    </div>
                                    {assetDetail?.relations?.acronyms?.length > 0 && (
                                        <div className="mt-4 flex flex-wrap gap-3">
                                            {assetDetail.relations.acronyms.map((a) => (
                                                <div key={a.relationId}>
                                                    <p className="text-sm font-medium flex items-center gap-1 mb-1">
                                                        has Acronym
                                                        <Tooltip arrow title={stripHtml(a.description) || ""}>
                                                            <span style={{ display: 'inline-flex', cursor: 'pointer' }}>
                                                                <Info size={12} />
                                                            </span>
                                                        </Tooltip>
                                                    </p>
                                                    <span className="flex items-center gap-1 border border-gray-300 rounded-full px-2 py-0.5 text-xs text-gray-700">
                                                        <span className="bg-[#e0f2fe] text-[#0369a1] font-medium px-1.5 py-0.5 rounded-full text-[10px]">ACR</span>
                                                        {a.targetName}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {assetDetail?.relations?.decronyms?.length > 0 && (
                                        <div className="mt-4 flex flex-wrap gap-3">
                                            {assetDetail.relations.decronyms.map((d) => (
                                                <div key={d.relationId}>
                                                    <p className="text-sm font-medium flex items-center gap-1 mb-1">
                                                        has Decronym
                                                        <Tooltip arrow title={stripHtml(d.description) || ""}>
                                                            <span style={{ display: 'inline-flex', cursor: 'pointer' }}>
                                                                <Info size={12} />
                                                            </span>
                                                        </Tooltip>
                                                    </p>
                                                    <span className="flex items-center gap-1 border border-gray-300 rounded-full px-2 py-0.5 text-xs text-gray-700">
                                                        <span className="bg-[#e0f2fe] text-[#0369a1] font-medium px-1.5 py-0.5 rounded-full text-[10px]">DCR</span>
                                                        {d.targetName}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}

                            {activeTab === "kpi-lineage" && (
                                <div className="mt-4">
                                    <GlossaryKpiLineage kpiName={termData.term} />
                                </div>
                            )}

                            {activeTab === "feedback" && (
                                <div className="mt-4 px-1">
                                    {feedbackLoading ? (
                                        <div className="flex justify-center py-10">
                                            <span className="text-sm text-gray-400">Loading feedback...</span>
                                        </div>
                                    ) : feedbackList.length === 0 ? (
                                        <div className="flex flex-col items-center justify-center py-16 text-center">
                                            <MessageSquareMore size={32} className="text-gray-300 mb-3" />
                                            <p className="text-sm font-medium text-gray-500">No feedback yet</p>
                                        </div>
                                    ) : (
                                        <div className="flex flex-col gap-4">
                                            {/* Active Issues */}
                                            {feedbackList.filter(i => i.type === "ISSUE").length > 0 && (
                                                <div>
                                                    <div className="flex items-center gap-2 mb-2 cursor-pointer" onClick={() => setIssuesOpen(!issuesOpen)}>
                                                        <TriangleAlert size={14} className="text-yellow-500" />
                                                        <p className="text-sm font-medium">Active Issues ({feedbackList.filter(i => i.type === "ISSUE").length})</p>
                                                        {issuesOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                                                    </div>
                                                    {issuesOpen && (
                                                        <div className="flex flex-col gap-2">
                                                            {feedbackList.filter(i => i.type === "ISSUE").map((item) => (
                                                                <div key={item.id} className="bg-[#FFFBEB] border border-[#f2efd0] rounded-lg px-3 py-2.5">
                                                                    <div className="flex items-center justify-between mb-1">
                                                                        <div className="flex">
                                                                            <Tooltip arrow title={item.user || "Current User"}>
                                                                                <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#F59E0B', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '9px', fontWeight: 600, cursor: 'default', flexShrink: 0 }}>
                                                                                    {item.user
                                                                                        ? item.user.includes('@')
                                                                                            ? item.user.split('@')[0].split('.').map(n => n[0]).join('').toUpperCase().slice(0, 2)
                                                                                            : item.user.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
                                                                                        : "CU"}
                                                                                </div>
                                                                            </Tooltip>
                                                                            <span className="text-xs font-medium text-[#f5a822] border border-[#f2efd0] px-2 py-0.5 rounded-full">
                                                                                {item.category || "Issue"}
                                                                            </span>
                                                                        </div>
                                                                        <span className="text-sm text-black">{formatDate(item.createdAt)}</span>
                                                                    </div>
                                                                    <p className="text-sm text-black m-0">{item.message}</p>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {/* Comments */}
                                            {feedbackList.filter(i => i.type === "COMMENT").length > 0 && (
                                                <div>
                                                    <div className="flex items-center gap-2 mb-2 cursor-pointer" onClick={() => setCommentsOpen(!commentsOpen)}>
                                                        <MessageSquare size={14} className="text-gray-500" />
                                                        <p className="text-sm font-medium">Comments ({feedbackList.filter(i => i.type === "COMMENT").length})</p>

                                                        {commentsOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                                                    </div>

                                                    {commentsOpen && (
                                                        <div className="flex flex-col gap-2">

                                                            {feedbackList.filter(i => i.type === "COMMENT").map((item) => (
                                                                <div key={item.id} className="bg-gray-100 rounded-lg px-3 py-2.5">
                                                                    <div className="flex items-center justify-between mb-1">
                                                                        <div className="flex items-center gap-2">
                                                                            <Tooltip arrow title={item.user || "Current User"}>
                                                                                <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#6366F1', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '9px', fontWeight: 600 }}>

                                                                                    {item.user

                                                                                        ? item.user.includes('@')

                                                                                            ? item.user.split('@')[0].split('.').map(n => n[0]).join('').toUpperCase().slice(0, 2)

                                                                                            : item.user.split(' ').map(n => n[0]).join('').toUpperCase()

                                                                                        : "CU"}
                                                                                </div>
                                                                            </Tooltip>

                                                                            {item.category && (
                                                                                <span className="text-sm text-black bg-gray-200 px-2 py-0.5 rounded-full">

                                                                                    {item.category}
                                                                                </span>

                                                                            )}
                                                                        </div>
                                                                        <span className="text-sm text-black">{formatDate(item.createdAt)}</span>
                                                                    </div>
                                                                    <p className="text-sm text-black m-0 ml-9">{item.message}</p>
                                                                </div>

                                                            ))}
                                                        </div>

                                                    )}
                                                </div>

                                            )}

                                        </div>
                                    )}
                                </div>
                            )}


                            {/* Footer Actions */}
                            <div className="mt-6 flex gap-3 justify-end">
                                <button
                                    type="button"
                                    onClick={() => setShowCommentModal(true)}
                                    className="flex items-center gap-1 text-black rounded border px-3 py-1 text-sm"
                                >
                                    <MessageSquareMore size={10} className="text-black" /> Comment
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setShowReportModal(true)}
                                    className="flex items-center gap-1 text-black rounded border px-3 py-1 text-sm"
                                >
                                    <MessageSquareMore size={10} /> Report Issue
                                </button>
                            </div>
                        </div>

                        {/* RIGHT PANEL */}
                        <div className="relative w-80 bg-[#F0FDFA] p-3">
                            <X
                                onClick={onClose}
                                className="absolute right-1 top-4 h-4 w-4 cursor-pointer text-gray-500 hover:text-gray-700"
                            />

                            <p className="text-xs  mb-[5px] font-bold text-[#bb1ccc]">OWNERS</p>
                            <div className="mb-3 flex items-center text-sm gap-2">
                                <User className="h-4 text-black" />
                                {isEditing ? (
                                    <input
                                        type="text"
                                        value={editedData.owner || ''}
                                        onChange={(e) => handleChange('owner', e.target.value)}
                                        className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm outline-none focus:border-blue-500"
                                    />
                                ) : (
                                    isEmpty(editedData.owner) ? <NoDataMessage /> : editedData.owner
                                )}
                            </div>

                            <p className="mb-2 text-xs font-bold text-[#bb1ccc]">
                                ASSET TYPE                        </p>
                            <p className="mb-4 text-sm flex gap-[10px] items-center">
                                <Shield size={10} />
                                {isEditing ? (
                                    <select
                                        value={editedData.assetType}
                                        onChange={(e) => handleChange('assetType', e.target.value)}
                                        className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm outline-none focus:border-blue-500"
                                    >
                                        <option value="Internal">Internal</option>
                                        <option value="Public">Public</option>
                                        <option value="Confidential">Confidential</option>
                                    </select>
                                ) : (
                                    isEmpty(editedData.assetType) ? <NoDataMessage /> : editedData.assetType
                                )}
                            </p>
                            <p className="mb-2 text-xs font-bold text-[#bb1ccc]">
                                STATUS                        </p>
                            <div className="mb-1 flex items-center text-sm text-[#15803D] gap-2">
                                {!isEmpty(editedData.status) && assetDetail?.statusDescription && (
                                    <Tooltip arrow title={stripHtml(assetDetail.statusDescription)}>
                                        <span style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>
                                            <Info size={14} />
                                        </span>
                                    </Tooltip>
                                )}    {isEmpty(editedData.status) ? <NoDataMessage /> : editedData.status}

                            </div>


                            <div className="mt-4 mb-2">
                                <p className="text-xs font-bold text-[#bb1ccc] mb-1">CDE</p>
                                <p className="text-sm" style={{
                                    color: termData.isCDE === "yes" ? "#15803D"
                                        : termData.isCDE === "no" ? "#D17A00"
                                            : "#6B7280"
                                }}>
                                    {termData.isCDE === null || termData.isCDE === undefined ? (
                                        <NoDataMessage />
                                    ) : termData.isCDE === "yes" ? (
                                        "Yes"
                                    ) : termData.isCDE === "no" ? (
                                        "No"
                                    ) : (
                                        termData.isCDE
                                    )}
                                </p>
                            </div>
                              <p className="mt-4 mb-2 text-xs font-bold text-[#bb1ccc]">
                                L3 Community :                 </p>
                            {isEditing ? (
                                <input
                                    type="text"
                                    value={editedData.cl3Community}
                                    onChange={(e) => handleChange('cl3Community', e.target.value)}
                                    className="mb-4 w-full border border-gray-300 rounded px-2 py-1 text-sm outline-none focus:border-blue-500"
                                />
                            ) : (
                                <p className="mb-4 text-sm">{isEmpty(editedData.cl3Community) ? <NoCommunityMessage /> : editedData.cl3Community}</p>
                            )}
                            <p className="mt-4 mb-2 text-xs font-bold text-[#bb1ccc]">
                                DOMAIN                 </p>
                            {isEditing ? (
                                <input
                                    type="text"
                                    value={editedData.department}
                                    onChange={(e) => handleChange('department', e.target.value)}
                                    className="mb-4 w-full border border-gray-300 rounded px-2 py-1 text-sm outline-none focus:border-blue-500"
                                />
                            ) : (
                                <p className="mb-4 text-sm">{isEmpty(editedData.department) ? <NoDataMessage /> : editedData.department}</p>
                            )}

                            <p className="mb-2 text-xs font-bold text-[#bb1ccc]">
                                LAST UPDATED
                            </p>
                            <span className="whitespace-nowrap text-sm">
                                {formatDate(term.date) ?? <NoDataMessage />}
                            </span>
                            {assetDetail?.id && (
                                <a
                                    href={`https://mars.collibra.com/asset/${assetDetail.id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-[12px] mt-2 font-semibold text-[#bb1ccc] mt-4 hover:underline mt-0.5 flex items-center gap-1"
                                >
                                    <Database size={13} className="text-[#bb1ccc] " />
                                    View in Collibra
                                </a>
                            )}

                        </div>
                    </div>
                </div>
                {/* Comment Modal */}

                {showCommentModal && (
                    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40">
                        <div className="bg-white rounded-xl shadow-xl w-[400px] p-3">
                            {/* Header */}
                            <div className="flex items-start justify-between mb-4">
                                <div className="flex items-center gap-3">
                                    <div className="bg-[#E8F4F8] p-2.5 rounded-full">
                                        <MessageSquareMore size={18} className="text-[#5BA4CF]" />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-base">Add a Comment</h3>
                                        <p className="text-xs text-black">for "{term?.displayName}"</p>
                                    </div>
                                </div>
                                <X
                                    size={16}
                                    className="cursor-pointer text-gray-400 hover:text-gray-600 mt-1"
                                    onClick={() => { setShowCommentModal(false); setCommentText(""); setCommentType("General Comment"); }}
                                />
                            </div>

                            {/* Comment Type */}
                            <div className="mb-4">
                                <p className="text-sm  text-black mb-2">Comment Type</p>
                                <div className="relative">
                                    <select
                                        value={commentType}
                                        onChange={(e) => setCommentType(e.target.value)}
                                        className="w-full border-2 border-purple-400 rounded-lg px-3 py-2.5 text-sm outline-none appearance-none bg-white cursor-pointer focus:border-purple-500"
                                    >
                                        <option value="General Comment">General Comment</option>
                                        <option value="Suggestion">Suggestion</option>
                                        <option value="Correction">Correction</option>
                                    </select>
                                    <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2">
                                            <path d="M6 9l6 6 6-6" />
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            {/* Your Comment */}
                            <div className="mb-4">
                                <p className="text-sm text-black  mb-2">Your Comment <span className="text-red-400">*</span></p>
                                <textarea
                                    value={commentText}
                                    onChange={(e) => setCommentText(e.target.value)}
                                    rows={4}
                                    className="w-full border border-gray-200 text-black rounded-lg px-3 py-2.5 text-sm outline-none resize-none bg-[#F9FAFB] focus:border-purple-400 focus:bg-white transition-colors"
                                    placeholder="Share your thoughts or suggestions..."
                                />
                            </div>

                            {/* Buttons */}
                            <div className="flex justify-end gap-3 w-[100%]">
                                <button
                                    onClick={() => { setShowCommentModal(false); setCommentText(""); setCommentType("General Comment"); }}
                                    className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50"
                                >
                                    Cancel
                                </button>
                                <button
                                    disabled={!commentText.trim()}
                                    onClick={() => handleFeedbackSubmit("COMMENT", commentText, commentType)}
                                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${commentText.trim()
                                        ? "text-purple-500 border border-purple-300 hover:bg-purple-50 cursor-pointer"
                                        : "text-purple-300 border border-purple-200 cursor-not-allowed"
                                        }`}
                                >
                                    {isSubmitting ? "Posting..." : "Post Comment"}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Report Issue Modal */}
                {showReportModal && (
                    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/40">
                        <div className="bg-white rounded-xl shadow-xl w-[400px] p-3">
                            {/* Header */}
                            <div className="flex items-start justify-between mb-6">
                                <div className="flex items-center gap-3">
                                    <div className="bg-[#FEF3C7] p-2.5 rounded-full">
                                        <Shield size={18} className="text-[#F59E0B]" />
                                    </div>
                                    <div>
                                        <h3 className="font-medium text-base">Report an Issue</h3>
                                        <p className="text-xs text-black">for "{term?.displayName}"</p>
                                    </div>
                                </div>
                                <X
                                    size={16}
                                    className="cursor-pointer text-gray-400 hover:text-gray-600 mt-1"
                                    onClick={() => { setShowReportModal(false); setReportText(""); setIssueType("Needs Review"); setIssueDropdownOpen(false); }}
                                />
                            </div>

                            <div className="mb-4">
                                <p className="text-sm text-black mb-2">Issue Type</p>
                                <div className="relative">
                                    <div

                                        onClick={() => setIssueDropdownOpen(!issueDropdownOpen)}

                                        className="w-full border border-gray-300 rounded-lg px-3 py-2.5 cursor-pointer bg-white flex justify-between items-start"
                                    >
                                        <div>
                                            <p className="text-sm font-medium m-0">{issueType}</p>
                                            <p className="text-xs  m-0">

                                                {issueOptions.find(o => o.value === issueType)?.desc}
                                            </p>
                                        </div>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2" className="mt-1 flex-shrink-0">
                                            <path d="M6 9l6 6 6-6" />
                                        </svg>
                                    </div>

                                    {issueDropdownOpen && (
                                        <div className="absolute top-full left-0 w-full bg-white border border-gray-200 rounded-lg shadow-md mt-1 z-[999]">
                                            {issueOptions.map((option) => (
                                                <div
                                                    key={option.value}
                                                    onClick={() => { setIssueType(option.value); setIssueDropdownOpen(false); }}
                                                    className={`flex items-start gap-[4px] justify-center px-1 py-2.5 cursor-pointer hover:bg-gray-50 ${issueType === option.value ? "bg-purple-50" : ""}`}
                                                >
                                                    <div className=" w-1 h-2  flex-shrink-0 flex items-center justify-center flex-shrink-0 mt-[6px]">
                                                        {issueType === option.value && <Check size={15} className="text-purple-600" />}
                                                    </div>
                                                    <div className="flex-1 min-w-0">
                                                        <p className={`text-sm text-black leading-tight mb-0.5 ${issueType === option.value ? "text-purple-600" : "text-gray-900"}`}>
                                                            {option.value}
                                                        </p>
                                                        <p className="text-xs text-black leading-tight m-0">{option.desc}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>


                            {/* Additional Details */}
                            <div className="mb-6">
                                <p className="text-sm text-black mb-2">Additional Detail</p>
                                <textarea
                                    value={reportText}
                                    onChange={(e) => setReportText(e.target.value)}
                                    rows={4}
                                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm outline-none resize-none bg-[#F9FAFB] focus:border-purple-400 focus:bg-white transition-colors"
                                    placeholder="Provide more context about the issue..."
                                />
                            </div>

                            {/* Buttons */}
                            <div className="flex justify-end gap-3 w-full">
                                <button
                                    onClick={() => { setShowReportModal(false); setReportText(""); setIssueType("Needs Review"); setIssueDropdownOpen(false); }}
                                    className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50"
                                >
                                    Cancel
                                </button>
                                <button
                                    disabled={!reportText.trim()}
                                    onClick={() => handleFeedbackSubmit("ISSUE", reportText, issueType)}
                                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${reportText.trim()
                                        ? "text-purple-500 border border-purple-300 hover:bg-purple-50 cursor-pointer"
                                        : "text-purple-300 border border-purple-200 cursor-not-allowed"
                                        }`}
                                >
                                    {isSubmitting ? "Submitting..." : "Submit Report"}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </ThemeProvider>

    );
}